<template>
  <section>
    <ReviewPopup v-if="isReviewWrite" @closePopup="closePopup"></ReviewPopup>
    <div class="mgt-40 mgb-24 d-flex align-items-baseline justify-content-between">
      <div class="t-headline10 font-m t-color-headline-black">{{ $t('30115') }}</div>
    </div>
  <div class="mdc-card mgb-24">
    <div class="d-flex">
    <div v-if="reviewSummaryList" class="mgl-50 mgr-50 pdl-8 pdr-8 pdt-34 pdb-34 flex-grow-1 d-flex flex-column justify-content-center">
      <div class="starHeading font-m t-center">{{ reviewSummaryList.average ? reviewSummaryList.average.toFixed(1) : '0.0' }}</div>
      <div class="d-flex mgt-10 justify-content-center">
        <i v-for="i in 5" :key="i" :class="i <= reviewSummaryList.average ? 't-color-starmark' : 't-color-textfieldGuidLine'" class="material-icons t-headline8">star</i>
      </div>
      <div class="t-body1 t-color-bodyGrayA mgt-6 t-center font-r">{{ $t('30082', {str: reviewSummaryList.count}) }}</div>
    </div>

      <div class="flex-grow-1 mgt-24 mgb-23 mgr-24 pdr-32 max-w-504">
        <div v-for="(value, point, index) in points" :key="point" class="d-flex justify-content-between align-items-center pdt-3 pdb-3 mgb-2">
          <div class="t-body3 font-r t-color-headlineBlack mgr-16 t-nowrap">{{ $t('30083', {str: Object.keys(points).length - index}) }}</div>
          <div class="position-relative  h-8 w-full b-radius4 flex-grow-1 starGraph">
            <div v-if="reviewCount" :style="'width:' + (value / reviewCount) * 100 + '%'" class="starGraphRange bg-starMark b-radius4"></div>
          </div>
          <div class="t-body3 font-r t-color-headlineBlack mgl-16 t-nowrap w-20">{{ value ? value : 0 }}</div>
        </div>
      </div>
    </div>
  </div>

    <div class="pdt-4 pdb-4 d-flex align-items-center justify-content-between mgb-16">
      <div class="mdc-form-field d-flex align-items-center" >
        <button v-if="!hasMyReview && writePermission === true" class="t-body3 t-color-secondaryBtnText font-r cursor-pointer mdc-button" @click="goToWriteReview" @keypress="goToWriteReview">{{ $t('30081') }}</button>
      </div>
      <div v-if="reviewCount > 0" class="h-24 d-flex align-items-center">
        <DropDown :sortOptions="sortOptions" class="mgt--12" @searchSort="searchSort"></DropDown>
      </div>
    </div>
    <div v-show="reviewCount > 0" class="divider"></div>
    <div class="micro-dgree-review-list">
      <div v-for="(review, index) in reviewDataUser && reviewDataUser.content" :key="index" :class="{'bg-iconInactiveHover' : getReviewOwner(review.reviewer.email)}" class="pdt-24 pdl-24">
        <ReviewItem :index="index" :review="review" :reviewSet="reviewSet" :isMember="isMember" :likeToggle="likeToggle" @likeReply="likeReply" @reviewKeyUpdate="reviewKeyUpdate" @menuActivate="menuActivate" @fetchReviewTotal="fetchReviewTotal"></ReviewItem>
      </div>
    </div>

    <div class="mgt-60 d-flex justify-content-center align-items-center mgb-80">
      <paginate v-if="reviewDataUser && reviewDataUser.content.length > 0"
          v-model="page"
          :click-handler="fetchReviewTotal"
          :container-class="'pagination'"
          :next-text="'<span class=material-icons >keyboard_arrow_right'"
          :page-class="'pagination-item'"
          :page-count="totalPageCount"
          :page-range="pageRangeComp"
          :prev-text="'<span class=material-icons >keyboard_arrow_left'">
      </paginate>
    </div>
    <div class="toggle-menu-scrim-rate d-none" @click="menuActivate" @keypress="menuActivate"></div>
  </section>
</template>

<script>
import microDegreeApi from "@/api/microDegreeApi";
import DropDown from "@/components/common/RightListSortOptions.vue"
import {MDCMenuSurface} from "@material/menu-surface";
import {storageConstants} from "@/utils/enum/StorageConstants";

const SortOptions = [
  {
    translateKey: "30085",
    sortValue: "auditor.created,desc",
    isShow: true,
  },
  {
    translateKey: "30086",
    sortValue: "likesCount,desc",
    isShow: false,
  },
  {
    translateKey: "30087",
    sortValue: "score,desc",
    isShow: false,
  },
  {
    translateKey: "30088",
    sortValue: "score,asc",
    isShow: false,
  },
];

export default {
  name: "Rating",

  props: ['reviewSet'],

  components: {
    DropDown,
    ReviewPopup: () => import('../review/ReviewPopup.vue'),
    ReviewItem: () => import('../review/ReviewItem.vue')
  },

  data() {
    return {
      page: 1,
      totalPageCount: 0,
      currentPage: 0,
      staticPageCount: 10,
      addedMenu: null,
      reviewDataUser: null,
      reviewSummaryList: null,
      isReviewWrite: false,
      reviewCount: 0,
      points: {
        "fivePoint": 0,
        "fourPoint": 0,
        "threePoint": 0,
        "twoPoint": 0,
        "onePoint": 0
      },
      sortOptions: SortOptions,
      isMember: JSON.parse(localStorage.getItem(storageConstants.userParams)).userId,
      hasMyReview: false,
      likeToggle: false,
      returnLike: 0,
      writePermission: false
    }
  },

  updated() {
    let addMenu = document.getElementById('addedMenu');
    if(addMenu) {
      this.addedMenu = MDCMenuSurface.attachTo(addMenu);
      this.addedMenu.setAnchorMargin({
        bottom: 10,
        left: -70,
        right: 16,
        top: 30,
      })
    }
  },

  mounted() {
    this.fetchReviewTotal();
    this.fetchReviewSummary();
    this.fetchAuthPermission();
  },

  computed: {
    isFirstPages() {
      return this.totalPage <= this.staticPageCount || this.currentPage >= Number(this.staticPageCount);
    },

    totalPageComp() {
      return this.isFirstPages ? this.totalPage : this.staticPageCount;
    },

    pageRangeComp() {
      return this.isFirstPages ? 9 : 11;
    }
  },

  methods: {
    menuActivate() {
      const toggleBackground = document.querySelector('.toggle-menu-scrim-rate');
      toggleBackground.classList.add('d-none');
      let openedMenubar = document.querySelector(".mdc-menu-surface--open");
      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }
    },

    getReviewOwner(id) {
      return id === this.isMember;
    },

    reviewKeyUpdate() {
      this.$emit('reviewKeyUpdate');
    },

    search() {
      this.reviewDataUser = null;
      this.fetchReviewTotal();
    },

    searchSort(value) {
      this.setSearchOption(value);
      this.search();
    },

    setSearchOption(value) {
      this.sortOptions = SortOptions;

      this.sortOptions.map((sort) => {
        sort.isShow = sort.sortValue === value;
      });
    },

    currentSortValue() {
      const sort = this.currentSort();
      return sort.sortValue.toString();
    },

    currentSort() {
      return this.sortOptions.find((sort) => sort.isShow === true);
    },

    fetchAuthPermission() {
      let params = this.setParams();
      microDegreeApi.authPermission(params).then((reponse) => {
        this.writePermission = reponse.data.data.registrationAuth;
      }).catch((err) => {})
    },

    fetchReviewTotal() {
      let params = this.setParams();
      microDegreeApi.learnOnlineViewReview(params).then((response) => {
        this.reviewDataUser = response.data.data;
        this.hasMyReview = _.some(this.reviewDataUser.content, (member) => {
          return member.reviewer.email === this.isMember
        })
        if (this.hasMyReview) {
          this.reviewDataUser.content.sort((a, b) => {
            if (a.reviewer.email === this.isMember && b.reviewer.email !== this.isMember) {
              return -1;
            } else if (a.reviewer.email !== this.isMember && b.reviewer.email === this.isMember) {
              return 1;
            } else {
              return 0;
            }
          });
        }
        this.totalPageCount = this.reviewDataUser.totalPages;
      })
    },

    fetchReviewSummary() {
      let params = this.setParams();
      microDegreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
        this.reviewSummaryList = response.data.data;
        this.reviewCount = response.data.data.count;
        const summaryData = { ...response.data.data };
        delete summaryData.average;
        delete summaryData.count;
        this.points = Object.assign(this.points, summaryData);
      })
    },

    likeReply(review) {
      let params = {
        degreeId: this.$route.params.degreeId,
        reviewId: review.id
      }
      let likeStatus = review.liked ? microDegreeApi.learnUnlikeReview(params) : microDegreeApi.learnLikeReview(params);
      likeStatus.then((response) => {
        this.returnLike = response.data.data.likesCount;
        this.fetchReviewTotal();
      })
    },

    setParams() {
      let params = {
        degreeId: this.$route.params.degreeId,
        sort: this.currentSortValue(),
        size: 5,
        page: this.page
      }
      return params;
    },

    goToWriteReview() {
      this.$router.push({
        name: "MicroDegreeReviewPost",
        params: { id: this.$route.params.degreeId },
        query: { learnId: this.$route.params.learnId }
      })
      // this.isReviewWrite = true;
    },

    closePopup() {
      this.isReviewWrite = false;
    },
  }
}
</script>

<style scoped>
.starHeading {
  font-size: 2rem;
}

.starGraph {
  background-color: #e1e1e1;
}

.starGraphRange {
  position: absolute;
  left: 0;
  top: 0;
  height: 8px;
  background-color: var(--Starmark);
}

.toggle-menu-scrim-rate {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px 24px
}

.bg-iconInactiveHover {
  background: var(--PrimaryInactiveHower);
}
</style>
